import { render, staticRenderFns } from "./rest-card.vue?vue&type=template&id=c1d30c00&scoped=true"
import script from "./rest-card.vue?vue&type=script&lang=ts"
export * from "./rest-card.vue?vue&type=script&lang=ts"
import style0 from "./rest-card.vue?vue&type=style&index=0&id=c1d30c00&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d30c00",
  null
  
)

export default component.exports